<!-- <amplify-authenticator> -->

<router-outlet></router-outlet>
<!-- <app-cookie-banner></app-cookie-banner>
<app-footer></app-footer> -->
<!-- <amplify-sign-out></amplify-sign-out>
</amplify-authenticator> -->
